import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { InvestmentPlanCreateRequestDTO } from '@backend/dto';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class CreateInvestmentPlanRequest extends Request<InvestmentPlanCreateRequestDTO, void> {
  constructor(options?: RequestOptions<InvestmentPlanCreateRequestDTO>) {
    super({
      ...options,
      method: 'POST',
      path: `${options?.version ?? '/v1'}/users/me/investment_plans/base`,
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    });
  }

  public execute(): Observable<void> {
    return super.execute().pipe(map((response: HttpResponse<any>) => response.body));
  }
}

export function createInvestmentPlan(
  options?: RequestOptions<InvestmentPlanCreateRequestDTO>
): CreateInvestmentPlanRequest {
  return new CreateInvestmentPlanRequest(options);
}
